import axios, { AxiosResponse } from 'axios'
import { useState, useEffect } from 'react'
import { TFunction } from 'react-i18next'

type Response = { result?: AxiosResponse<any>; error?: any }
type Name = { th: string; en: string }
export type Lookup = { id: string; name: Name }

export interface Form {
    provinceID?: number | string
    districtID?: number | string
    subDistrictID?: number | string
}

export const validate = async (values: Form, t: TFunction<'translation'>) => {
    const errors: Partial<Form> = {}
    if (!values.provinceID) {
        errors.provinceID = `${t('LABEL.SELECT_REQUIRED')}` as any
    }
    if (!values.districtID) {
        errors.districtID = `${t('LABEL.SELECT_REQUIRED')}` as any
    }
    if (!values.subDistrictID) {
        errors.subDistrictID = `${t('LABEL.SELECT_REQUIRED')}` as any
    }
    return errors
}

const useAdminpoly = () => {
    const [provinceList, setProvinceList] = useState<Lookup[]>([])
    const [districtList, setDistrictList] = useState<Lookup[]>([])
    const [subdistrictList, setSubdistrictList] = useState<Lookup[]>([])

    useEffect(() => {
        // callServiceAdminpoly()
    }, [])

    const handleSubmit = (values: any) => {
        console.log('adminpoly submit', values)
    }

    const callServiceAdminpoly = async (
        provinceID?: number | string,
        districtID?: number | string,
    ): Promise<Response> => {
        try {
            const url = new URL(`${process.env.REACT_APP_API}/api/lookup/adminpoly`)
            if (provinceID) url.searchParams.set('provinceID', String(provinceID))
            if (districtID) url.searchParams.set('districtID', String(districtID))
            const result = await axios.get(url.toString())

            if (result) {
                if (districtID) setSubdistrictList(result.data)
                else if (provinceID) setDistrictList(result.data)
                else setProvinceList(result.data)
            }

            return { result }
        } catch (error) {
            return { error }
        }
    }

    return {
        onSubmit: handleSubmit,
        callServiceAdminpoly,
        provinceList,
        districtList,
        subdistrictList,
    }
}

export default useAdminpoly
